import React from 'react';
import { dataToPoints, arrayMin, arrayMax } from './dataProcessing';
export const SparklinesSpots = ({
  data = [],
  displayData,
  color = '#25948C',
  style,
  size = 2,
  fontSize = 10,
  margin = 0,
  fontColor = 'white',
  max,
  min,
  width,
  height,
  limit,
  noText,
  dText
}) => {
  if (!data || data.length === 0) return null;
  const points = dataToPoints({
    data,
    limit,
    width: width,
    height: height,
    margin,
    max,
    min
  });

  const getYheight = y => {
    if (dText) {
      const ypoints = points.map(point => point.y);
      const minYpoint = arrayMin(ypoints);
      const maxYpoint = arrayMax(ypoints);

      if (y === maxYpoint) {
        return Math.max(y - 10, 10);
      } else if (y === minYpoint) {
        return Math.max(y + 10, 10);
      }

      return y;
    }

    return height && height / 2;
  };

  const lineStyle = {
    stroke: color || style && style.stroke,
    strokeWidth: style && style.strokeWidth || '1',
    fill: color
  };
  const dataInUse = displayData || data;
  const startSpot = points && /*#__PURE__*/React.createElement("circle", {
    cx: points[0].x,
    cy: points[0].y,
    r: size,
    style: lineStyle
  });
  const startText = points && dataInUse && /*#__PURE__*/React.createElement("text", {
    x: points[0].x - 20,
    y: getYheight(points[0].y),
    fill: fontColor,
    fontSize: `${fontSize}px`
  }, dataInUse[0]);
  const endSpot = points && /*#__PURE__*/React.createElement("circle", {
    cx: points[points.length - 1].x,
    cy: points[points.length - 1].y,
    r: size,
    style: lineStyle
  });
  const endText = points && points.length > 1 && dataInUse && /*#__PURE__*/React.createElement("text", {
    x: points[points.length - 1].x + 6,
    y: getYheight(points[points.length - 1].y),
    fill: fontColor,
    fontSize: `${fontSize}px`
  }, dataInUse[dataInUse.length - 1]);
  return /*#__PURE__*/React.createElement("g", null, !noText && startText, startSpot, endSpot, !noText && endText);
};
export default SparklinesSpots;